module.exports = "data:text/x-markdown;base64,U28gdGhlcmUncyBhIGZyZWUgc2hvcCBhcm91bmQgYW5kIG5vIG9uZSBpcyBndWFyZGluZyBpdC4KVGhlcmUncmUgMSBldGhlciBpbmNsdWRlcyBpbiB0aGUgc3RvcmUuCllvdSBqdXN0IGhhcyB0byBmaW5kIGEgd2F5IHRvIHRha2UgYWxsIHRoZSBtb25leSBvdXQg8J+YiS4KCkhlcmUncyBhIGxpdHRsZSB0aXA6CiogaG93IHRvIGNhbGwgZnVuY3Rpb24gZnJvbSBvdGhlciBjb250cmFjdHM/Cg=="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/freeshop.md
// module id = 1379
// module chunks = 0